import BaseService from './base-service';

const cleanQuery = (query = {}) => Object.entries(query).reduce((result, [key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
        result[key] = value;
    }
    return result;
}, {});

export default class BillingService extends BaseService {
    constructor() {
        super('billing');
    }

    getSummary(query) {
        return this.__get(this.__injectQueryParams(`${this.url}/summary`, cleanQuery(query)));
    }

    getProviderStatus(query) {
        return this.__get(this.__injectQueryParams(`${this.url}/provider-status`, cleanQuery(query)));
    }

    listCharges(query) {
        return this.__get(this.__injectQueryParams(`${this.url}/charges`, cleanQuery(query)));
    }

    listSubscriptions(query) {
        return this.__get(this.__injectQueryParams(`${this.url}/subscriptions`, cleanQuery(query)));
    }

    createCharge(data) {
        return this.__post(`${this.url}/commands/charges`, data);
    }

    createSubscription(data) {
        return this.__post(`${this.url}/commands/subscriptions`, data);
    }

    cancelSubscription(id, query = {}) {
        return this.__delete(this.__injectQueryParams(`${this.url}/commands/subscriptions/${id}`, cleanQuery(query)));
    }

    syncCharge(id, query = {}) {
        return this.__post(this.__injectQueryParams(`${this.url}/commands/charges/${id}/sync`, cleanQuery(query)));
    }

    getChargePaymentDetails(id, query = {}) {
        return this.__get(this.__injectQueryParams(`${this.url}/commands/charges/${id}/payment-details`, cleanQuery(query)));
    }

    syncSubscription(id, query = {}) {
        return this.__post(this.__injectQueryParams(`${this.url}/commands/subscriptions/${id}/sync`, cleanQuery(query)));
    }

    __owned(path, ownerCustomerId, query = {}) {
        return this.__injectQueryParams(`${this.url}/${path}`, cleanQuery({ownerCustomerId, ...query}));
    }

    getDelinquencySettings(ownerCustomerId) {
        return this.__get(this.__owned('delinquency-settings', ownerCustomerId));
    }

    updateDelinquencySettings(ownerCustomerId, {graceDays, blockVehicles}) {
        return this.__put(this.__owned('delinquency-settings', ownerCustomerId), {graceDays, blockVehicles});
    }

    listBlocks(ownerCustomerId, {status, customerId, deviceId} = {}) {
        return this.__get(this.__owned('blocks', ownerCustomerId, {status, customerId, deviceId}));
    }

    releaseBlock(ownerCustomerId, id, note) {
        return this.__post(this.__owned(`blocks/${id}/release`, ownerCustomerId), {note});
    }

    listBlockExemptions(ownerCustomerId) {
        return this.__get(this.__owned('block-exemptions', ownerCustomerId));
    }

    createBlockExemption(ownerCustomerId, body) {
        const {customerId, deviceId, note} = body;
        return this.__post(this.__owned('block-exemptions', ownerCustomerId), cleanQuery({customerId, deviceId, note}));
    }

    removeBlockExemption(ownerCustomerId, id) {
        return this.__delete(this.__owned(`block-exemptions/${id}`, ownerCustomerId));
    }

    listBlockRuns(ownerCustomerId) {
        return this.__get(this.__owned('block-runs', ownerCustomerId));
    }

    listBlockRunDispatches(ownerCustomerId, runId) {
        return this.__get(this.__owned(`block-runs/${runId}/dispatches`, ownerCustomerId));
    }
}
